import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DevicesOsUpdateStatusSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { DeviceOsUpdateStatusComponent } from './device-os-update-status.component';

@Component({
  selector: 'era-device-os-update-status',
  templateUrl: './device-os-update-status.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceOsUpdateStatusComponent],
})
export class DeviceOsUpdateStatusContainerComponent {
  private readonly store = inject(Store);

  readonly osUpdateStatus = this.store.selectSignal(DevicesOsUpdateStatusSelectors.selectOsUpdateStatusByUdid);
}
